/**
 * excel模块导出接口列表
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
var apiTarget = {
    test1:"/test/excel",
    //test1Count:"/test/test1Count"
    // 使用费查询明细excel输出
    useChargeExcelDetail:"/registpay/excel-detail",
    // 使用费查询明细excel输出数量
    useChargeExcelDetailCount:"/registpay/excel-detail-count",
    // 使用费查询合计excel输出
    useChargeExcelTotal:"/registpay/excel-sum",
    // 使用费查询合计excel输出数量
    useChargeExcelTotalCount:"/registpay/excel-sum-count",
    // 即使订货查询-311订货查询excel输出
    instantOrder311:"/instant/311order/excel",
    // 即使订货查询-311订货查询excel输出数量
    instantOrder311Count:"/instant/311order/excel-count",
    //最终订货excel导出
    lastorderExcel:"/lastorder/excel",
    // 即使订货查询-st订货查询excel输出
    instantStOrder:"/instant/storder/excel",
    // 即使订货查询-st订货查询excel输出数量
    instantStOrderCount:"/instant/storder/excel-count",
    // 即使订货查询-央厨订货查询excel输出
    instantCkOrder:"/instant/ckorder/excel",
    // 即使订货查询-央厨订货查询excel输出数量
    instantCkOrderCount:"/instant/ckorder/excel-count",
    // 进退货查询-excel输出
    delivery:"/delivery/excel",
    // 进退货查询-excel输出数量
    deliveryCount:"/delivery/excel-count",
    // 进退货查询明细excel输出
    deliveryDetail:"/delivery/detail-excel",
    // 进退货查询明细excel输出数量
    deliveryDetailCount:"/delivery/detail-excel-count",
    // 单品进销存excel输出
    itemSaleStock:"/item/excel",
    // 单品进销存excel输出数量
    itemSaleStockCount:"/item/excel-count",
    // 转账单通知查询 - 转账单查询 - 列表excel导出
    transferbills_list_excel:"/transferbills/excel",
    //转账通知单查询-转账单查询-根据传票号执行excel导出
    transferbills_list_info_show_excel:"/transferbills/po-num-new/{?}/excel",
    //转账通知单查询-转账单查询-根据明细单号执行excel导出
    transferbills_list_transfer_show_excel:"/transferbills/po-num/{?}/excel",
    //转账通知单查询-店中店修正传票查询-店中店修正传票结果集转出EXCEL
    in_shop_list_excel:"/in-shop/excel",
    //转账通知单查询-店中店修正传票查询-根据传票号码得到店中店修正传票明细结果集-EXCEL导出
    in_shop_detail_excel:"/in-shop/{?}/excel",
    //商品基础信息查询-查询结果excel导出
  goods_query_excel:"/itemquery/s-excel",
}
const api = {

    /*
      发起excel导出业务，apiName表示请求的最终url
      params:对象/替换url{?}的值
    */
    export(apiName,params){
        var placeholder = "{?}"
        var apiUrl = apiTarget[apiName];
        if(apiUrl.includes(placeholder)){
          apiUrl = apiUrl.replace(placeholder, params.replaceParam)
        }
        return axios.get(`${Vue.prototype.$base.API_PATH}`+""+apiUrl,{
            params: params,
            mask:false
        });
    },
    //查看API是否存在
    apiExist(apiName){
        return apiTarget[apiName]||null;
    },
    //查询指定excel执行状态
    state(key){
        return axios.post(`${Vue.prototype.$base.API_PATH}/appendix/excel/state`,{"key":key}, {
        mask: false
      });
    },
    //下载excel文件
    down(key) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/appendix/excel/`+key, {
        params: null,
        responseType: 'blob',//文件流下载类型
      });
   },
 }
export default api;



// WEBPACK FOOTER //
// ./src/api/excel.js